module.exports = __webpack_public_path__ + "static/media/almeida-junior.e5c38f37.png";